// extracted by mini-css-extract-plugin
module.exports = {"tosLink":"RegisterForm_tosLink__3gVdD","tosPhrase":"RegisterForm_tosPhrase__e_R5u","column":"RegisterForm_column__1GMVo"};